<template>
  <router-link
    :to="to"
    class="push-button"
  >
    <div
      class="background"
      :class="background"
    />
    <div class="label">
      <span
        v-for="(line, index) in labelLines"
        :key="index"
      >{{ line }}</span>
    </div>
  </router-link>
</template>
<script>
export default {
  name: 'PushButton',
  props: {
    label: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: false,
      default: '',
    },
    background: {
      type: String,
      required: true,
    },
  },
  computed: {
    labelLines() {
      return this.label.split('\n');
    },
  },
};
</script>
<style lang="stylus" scoped>
.push-button {
  display: flex;
  border-radius: 10px;
  border: 1px solid var(--main-color);
  width: 100%;

  font-size: 14px;
  justify-content: flex-start;
  align-items: flex-end;
  min-height: 80px;
  position: relative;
  overflow: hidden;

  &:hover {
    .background {
      transform: scale(1.1);
      filter: brightness(1.1);
    }
    .label {
      transform: translateY(-5px);}
  }
  div.background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    background-size: cover;
    transition: all 0.5s ease;
  }
  div.label {
    display: flex;
    flex-direction: column;
    color: var(--text-color);
    text-align: left;
    padding: 10px;
    z-index: 1;
    transition: all 0.5s ease;

    span {
      border-radius: 4px;
      background: var(--main-color);
      width: fit-content;
      padding: 1px 3px;
    }
  }
}
</style>
